"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputTypeOptions = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _FormsList = _interopRequireDefault(require("./components/Forms/Forms/FormsList"));

var _FormsAdd = _interopRequireDefault(require("./components/Forms/Forms/FormsAdd"));

var _FormsEdit = _interopRequireDefault(require("./components/Forms/Forms/FormsEdit"));

var _FormsForm = _interopRequireDefault(require("./components/Forms/Forms/FormsForm"));

var _FormFieldsList = _interopRequireDefault(require("./components/Forms/FormFields/FormFieldsList"));

var _FormFieldsAdd = _interopRequireDefault(require("./components/Forms/FormFields/FormFieldsAdd"));

var _FormFieldsEdit = _interopRequireDefault(require("./components/Forms/FormFields/FormFieldsEdit"));

var _FormFieldsForm = _interopRequireDefault(require("./components/Forms/FormFields/FormFieldsForm"));

var _FormSubmissionsList = _interopRequireDefault(require("./components/Forms/FormSubmissions/FormSubmissionsList"));

var _FormSubmissionsView = _interopRequireDefault(require("./components/Forms/FormSubmissions/FormSubmissionsView"));

var _RedirectsList = _interopRequireDefault(require("./components/Redirects/RedirectsList"));

var _RedirectsAdd = _interopRequireDefault(require("./components/Redirects/RedirectsAdd"));

var _RedirectsEdit = _interopRequireDefault(require("./components/Redirects/RedirectsEdit"));

var _RedirectsForm = _interopRequireDefault(require("./components/Redirects/RedirectsForm"));

var _RedirectsImport = _interopRequireDefault(require("./components/Redirects/RedirectsImport"));

var _RedirectsImportStatus = _interopRequireDefault(require("./components/Redirects/RedirectsImportStatus"));

var _NavigationList = _interopRequireDefault(require("./components/Navigation/NavigationList"));

var _NavigationEdit = _interopRequireDefault(require("./components/Navigation/NavigationEdit"));

var _NavigationForm = _interopRequireDefault(require("./components/Navigation/NavigationForm"));

var _TasksList = _interopRequireDefault(require("./components/Tasks/Tasks/TasksList"));

var _TasksEdit = _interopRequireDefault(require("./components/Tasks/Tasks/TasksEdit"));

var _TasksForm = _interopRequireDefault(require("./components/Tasks/Tasks/TasksForm"));

var _TaskRunsList = _interopRequireDefault(require("./components/Tasks/TaskRuns/TaskRunsList"));

var _CountriesList = _interopRequireDefault(require("./components/Countries/CountriesList"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defaults = {
  FormsList: _FormsList["default"],
  FormsAdd: _FormsAdd["default"],
  FormsEdit: _FormsEdit["default"],
  FormsForm: _FormsForm["default"],
  FormFieldsList: _FormFieldsList["default"],
  FormFieldsAdd: _FormFieldsAdd["default"],
  FormFieldsEdit: _FormFieldsEdit["default"],
  FormFieldsForm: _FormFieldsForm["default"],
  FormSubmissionsList: _FormSubmissionsList["default"],
  FormSubmissionsView: _FormSubmissionsView["default"],
  RedirectsList: _RedirectsList["default"],
  RedirectsAdd: _RedirectsAdd["default"],
  RedirectsEdit: _RedirectsEdit["default"],
  RedirectsForm: _RedirectsForm["default"],
  RedirectsImport: _RedirectsImport["default"],
  RedirectsImportStatus: _RedirectsImportStatus["default"],
  NavigationList: _NavigationList["default"],
  NavigationEdit: _NavigationEdit["default"],
  NavigationForm: _NavigationForm["default"],
  TasksList: _TasksList["default"],
  TasksEdit: _TasksEdit["default"],
  TasksForm: _TasksForm["default"],
  TaskRunsList: _TaskRunsList["default"],
  CountriesList: _CountriesList["default"]
};

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var components = _objectSpread(_objectSpread({}, defaults), options);

  var FormsList = components.FormsList,
      FormsAdd = components.FormsAdd,
      FormsEdit = components.FormsEdit,
      FormsForm = components.FormsForm,
      FormFieldsList = components.FormFieldsList,
      FormFieldsAdd = components.FormFieldsAdd,
      FormFieldsEdit = components.FormFieldsEdit,
      FormFieldsForm = components.FormFieldsForm,
      FormSubmissionsList = components.FormSubmissionsList,
      FormSubmissionsView = components.FormSubmissionsView,
      RedirectsList = components.RedirectsList,
      RedirectsAdd = components.RedirectsAdd,
      RedirectsEdit = components.RedirectsEdit,
      RedirectsForm = components.RedirectsForm,
      RedirectsImport = components.RedirectsImport,
      RedirectsImportStatus = components.RedirectsImportStatus,
      NavigationList = components.NavigationList,
      NavigationEdit = components.NavigationEdit,
      NavigationForm = components.NavigationForm,
      TasksList = components.TasksList,
      TasksEdit = components.TasksEdit,
      TasksForm = components.TasksForm,
      TaskRunsList = components.TaskRunsList,
      CountriesList = components.CountriesList;
  return {
    routes: [{
      path: '/forms',
      render: function render(_ref) {
        var match = _ref.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: FormsList
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/add"),
          exact: true
        }, function (props) {
          return /*#__PURE__*/_react["default"].createElement(FormsAdd, _extends({}, props, {
            FormsForm: FormsForm
          }));
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/:id"),
          exact: true
        }, function (props) {
          return /*#__PURE__*/_react["default"].createElement(FormsEdit, _extends({}, props, {
            FormsForm: FormsForm
          }));
        }));
      }
    }, {
      path: '/form-fields',
      render: function render(_ref2) {
        var match = _ref2.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: FormFieldsList
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/add"),
          exact: true
        }, function (props) {
          return /*#__PURE__*/_react["default"].createElement(FormFieldsAdd, _extends({}, props, {
            FormFieldsForm: FormFieldsForm
          }));
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/:id"),
          exact: true
        }, function (props) {
          return /*#__PURE__*/_react["default"].createElement(FormFieldsEdit, _extends({}, props, {
            FormFieldsForm: FormFieldsForm
          }));
        }));
      }
    }, {
      path: '/form-submissions',
      render: function render(_ref3) {
        var match = _ref3.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: FormSubmissionsList
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/:id"),
          exact: true,
          component: FormSubmissionsView
        }));
      }
    }, {
      path: '/redirects',
      render: function render(_ref4) {
        var match = _ref4.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: RedirectsList
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/import"),
          exact: true,
          component: RedirectsImport
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/import/:id"),
          exact: true,
          component: RedirectsImportStatus
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/add"),
          exact: true
        }, function (props) {
          return /*#__PURE__*/_react["default"].createElement(RedirectsAdd, _extends({}, props, {
            RedirectsForm: RedirectsForm
          }));
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/:redirect"),
          exact: true
        }, function (props) {
          return /*#__PURE__*/_react["default"].createElement(RedirectsEdit, _extends({}, props, {
            RedirectsForm: RedirectsForm
          }));
        }));
      }
    }, {
      path: '/tasks',
      render: function render(_ref5) {
        var match = _ref5.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: TasksList
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/task-runs"),
          exact: true,
          component: TaskRunsList
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/:task"),
          exact: true
        }, function (props) {
          return /*#__PURE__*/_react["default"].createElement(TasksEdit, _extends({}, props, {
            TasksForm: TasksForm
          }));
        }));
      }
    }, {
      path: '/countries',
      render: function render(_ref6) {
        var match = _ref6.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: CountriesList
        }));
      }
    }, {
      path: '/menus',
      render: function render(_ref7) {
        var match = _ref7.match;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url),
          exact: true,
          component: NavigationList
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: "".concat(match.url, "/:menuCode"),
          exact: true
        }, function (props) {
          return /*#__PURE__*/_react["default"].createElement(NavigationEdit, _extends({}, props, {
            NavigationForm: NavigationForm
          }));
        }));
      }
    }]
  };
};

exports["default"] = _default;
var inputTypeOptions = [{
  label: 'Text',
  value: 'text'
}, {
  label: 'Textarea',
  value: 'textarea'
}, {
  label: 'Select',
  value: 'select'
}, {
  label: 'Radio',
  value: 'radio'
}, {
  label: 'Checkbox',
  value: 'checkbox'
}, {
  label: 'Checkbox Group',
  value: 'multi-select'
}, {
  label: 'File',
  value: 'file'
}, {
  label: 'Date',
  value: 'date'
}, {
  label: 'Declaration',
  value: 'declaration'
}, {
  label: 'Email',
  value: 'email'
}, {
  label: 'Telephone',
  value: 'telephone'
}, {
  label: 'Postcode',
  value: 'postcode'
}, {
  label: 'Hidden',
  value: 'hidden'
}];
exports.inputTypeOptions = inputTypeOptions;